import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// NewUser page components
import FormField from "components/FormField";

export default function PAInfo({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    number,
    name,
    regional,
  } = formField;
  const {
    number: numberV,
    name: nameV,
    regional: regionalV,
  } = values;

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">Sobre o PA</MDTypography>
        <MDTypography variant="button" color="text">
          Informações obrigatórias
        </MDTypography>
      </MDBox>
      <MDBox mt={1.625}>
        <FormField
          type={number.type}
          label={number.label}
          name={number.name}
          value={numberV}
          placeholder={number.placeholder}
          error={errors.number && touched.number}
          success={numberV.length > 0 && !errors.number}
        />
        <FormField
          type={name.type}
          label={name.label}
          name={name.name}
          value={nameV}
          placeholder={name.placeholder}
          error={errors.name && touched.name}
          success={nameV.length > 0 && !errors.name}
        />
        <FormField
          type={regional.type}
          label={regional.label}
          name={regional.name}
          value={regionalV}
          placeholder={regional.placeholder}
          error={errors.regional && touched.regional}
          success={regionalV.length > 0 && !errors.regional}
        />
      </MDBox>
    </MDBox>
  );
}

// typechecking props for PAInfo
PAInfo.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};